// extracted by mini-css-extract-plugin
export default {"backdrop":"style_backdrop__PzyJ9","dialog":"style_dialog__iaqVy","title":"style_title__ynKHM","text":"style_text__xoEbG","link":"style_link__60FCA","actions":"style_actions__1MmZn"};